import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';

var BUTTON_SHAPE = {
  CIRCLE: 'circle',
  PILL: 'pill'
};
var BUTTON_TYPE = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit'
};
var BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  GHOST: 'ghost',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
  UNKNOWN: 'unknown'
};
var BUTTON_SIZE = {
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small'
};
var BUTTON_ICON_SIZE = _objectSpread2(_objectSpread2({}, BUTTON_SIZE), {}, {
  TINY: 'tiny'
});
var BUTTON_GROUP_ALIGNMENT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var BUTTON_TEXT_POSITION_MAP = {
  HIDDEN: 'hidden',
  LEFT: 'left',
  RIGHT: 'right'
};
var BUTTON_PROP_TYPES = {
  ariaLabel: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isPending: PropTypes.bool,
  onClick: PropTypes.func,
  shape: PropTypes.oneOf(Object.values(BUTTON_SHAPE)),
  size: PropTypes.oneOf(Object.values(BUTTON_ICON_SIZE)),
  target: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
  variant: PropTypes.oneOf(Object.values(BUTTON_VARIANT))
};

export { BUTTON_GROUP_ALIGNMENT, BUTTON_ICON_SIZE, BUTTON_PROP_TYPES, BUTTON_SHAPE, BUTTON_SIZE, BUTTON_TEXT_POSITION_MAP, BUTTON_TYPE, BUTTON_VARIANT };
//# sourceMappingURL=Button.constants.js.map
